import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Css/TeacherManagment.css";
import { useNavigate } from 'react-router-dom';
import API_BASE from "../config/api";

const StudentManagment = () => {
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [questions, setQuestions] = useState([]);
  const token = localStorage.getItem("token");
  const [softwares, setSoftwares] = useState([]);
  const [selectedSoftwareId, setSelectedSoftwareId] = useState("");
  const navigate = useNavigate();
  const [dashboardCounts, setDashboardCounts] = useState({
    totalStudents: 0,
    activeStudents: 0,
    inactiveStudents: 0,
  });

  const sortedData = questions;
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

const handleViewClick = (studentId) => {
  navigate(`/dashboard/studentview/${studentId}`);
};

const handleEditClick = (studentId) => {
  navigate(`/dashboard/studentedit/${studentId}`);
};


  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setShowDeletePopup(true);
  };

  const cancelDelete = () => {
    setShowDeletePopup(false);
    setDeleteIndex(null);
  };
  useEffect(() => {
  fetchDashboardCounts();
}, []);

  const fetchDashboardCounts = async () => {
  try {
    const res = await axios.get(
      `${API_BASE}/api/instituteadmin/students/dashboard-counts`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setDashboardCounts(res.data);
  } catch (error) {
    console.error("Failed to load dashboard counts", error);
  }
};


  useEffect(() => {
    fetchSoftwares();
  }, []);

  const fetchSoftwares = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/instituteadmin/students/softwares`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSoftwares(res.data);
    } catch (error) {
      console.error("Failed to load softwares", error);
    }
  };


  const filteredData = questions.filter((stu) => {
    const fullName = `${stu.firstName ?? ""} ${stu.lastName ?? ""}`.toLowerCase();
    const search = searchQuery.toLowerCase();

    return (
      fullName.includes(search) ||
      stu.studentId?.toString().toLowerCase().includes(search)
    );
  });


  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  useEffect(() => {
    fetchStudents();
  }, [selectedSoftwareId, currentPage, rowsPerPage, searchQuery]);


  const fetchStudents = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/instituteadmin/students`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            PageNumber: currentPage,
            PageSize: rowsPerPage,
            Search: searchQuery,
            SoftwareId: selectedSoftwareId || null,
          },
        }
      );
      setQuestions(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };


  const confirmDelete = async () => {
    try {
      await axios.delete(
        `${API_BASE}/api/instituteadmin/students/${questions[deleteIndex].id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      fetchStudents(); // reload list
      setShowDeletePopup(false);
    } catch (error) {
      console.error("Delete failed", error);
    }
  };

  return (
    <div className="student-wrapper">
      <div className="notification-header">
        <h2>विद्यार्थी व्यवस्थापन</h2>
        <button
          className="stu-btn"
          onClick={() => navigate("/dashboard/studentform")}
        >
          नवीन विद्यार्थी जोडा
        </button>
      </div>
      {/* Top Filters */}
      <div className="filters">
        <div className="search-wrapper-exam">
          <svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
            <path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484" /></svg>
          <input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
        </div>
        <select
          value={selectedSoftwareId}
          onChange={(e) => {
            setSelectedSoftwareId(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option value="">परीक्षेचे नाव</option>

          {softwares.map((sw, index) => (
            <option
              key={index}
              value={sw.softwareId ?? sw.software?.id}
            >
              {sw.software?.softwareName}
            </option>
          ))}
        </select>



      </div>

      <div className="stat">
        <div className="stat purple">
          <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M17.9587 21.6667C17.4895 21.6667 17.1039 21.4872 16.802 21.1283C16.5003 20.7692 16.387 20.3503 16.462 19.8717L16.8016 17.705C16.9382 16.9167 17.3138 16.2688 17.9282 15.7613C18.5424 15.2538 19.2356 15 20.0078 15C20.7978 15 21.4999 15.2538 22.1141 15.7613C22.7285 16.2688 23.1041 16.9167 23.2407 17.705L23.5803 19.8717C23.6553 20.3503 23.542 20.7692 23.2403 21.1283C22.9384 21.4872 22.5528 21.6667 22.0837 21.6667H17.9587ZM6.26074 22.8108C5.81158 22.8386 5.4181 22.7528 5.08033 22.5533C4.74255 22.3536 4.52255 22.0442 4.42033 21.625C4.36477 21.4392 4.35616 21.2586 4.39449 21.0833C4.4331 20.9081 4.48658 20.7378 4.55491 20.5725C4.55491 20.5933 4.54102 20.5521 4.51324 20.4487C4.47908 20.3932 4.38283 20.156 4.22449 19.7371C4.19033 19.4893 4.22199 19.2596 4.31949 19.0479C4.41671 18.8365 4.54324 18.6539 4.69908 18.5C4.72046 18.5 4.73755 18.4829 4.75033 18.4488C4.79116 18.0743 4.94935 17.759 5.22491 17.5029C5.50046 17.2468 5.83046 17.1187 6.21491 17.1187C6.23435 17.1187 6.42352 17.1529 6.78241 17.2212L6.87533 17.2117C6.97144 17.1047 7.09644 17.0246 7.25033 16.9712C7.40421 16.9176 7.56769 16.8908 7.74074 16.8908C7.96241 16.8908 8.1588 16.9235 8.32991 16.9887C8.5013 17.054 8.6363 17.1651 8.73491 17.3221C8.75491 17.3221 8.76977 17.3276 8.77949 17.3388C8.78949 17.3501 8.80435 17.3558 8.82408 17.3558C9.08463 17.3836 9.32199 17.4701 9.53616 17.6154C9.75005 17.761 9.90796 17.9597 10.0099 18.2117C10.0441 18.3633 10.0596 18.4974 10.0566 18.6137C10.0532 18.7301 10.0238 18.8503 9.96824 18.9742C9.96824 18.9806 9.98213 19.0254 10.0099 19.1087C10.1616 19.2607 10.2716 19.4119 10.3399 19.5625C10.4085 19.7131 10.4428 19.8814 10.4428 20.0675C10.4428 20.1144 10.3914 20.3206 10.2887 20.6858C10.2823 20.6986 10.2823 20.7435 10.2887 20.8204C10.31 20.8846 10.3271 21.0428 10.3399 21.295C10.3399 21.7111 10.1655 22.0678 9.81658 22.365C9.46769 22.6622 9.04394 22.8108 8.54533 22.8108H6.26074ZM32.5466 22.9487C31.8982 22.9487 31.3385 22.7151 30.8674 22.2479C30.3963 21.7807 30.1607 21.219 30.1607 20.5629C30.1607 20.3243 30.1949 20.1026 30.2632 19.8979C30.3319 19.6932 30.4248 19.4932 30.542 19.2979L29.7062 18.5721C29.507 18.4171 29.472 18.221 29.6012 17.9837C29.7303 17.7468 29.9142 17.6283 30.1528 17.6283H32.5387C33.1948 17.6283 33.7531 17.8593 34.2137 18.3213C34.6739 18.7832 34.9041 19.3385 34.9041 19.9871V20.5771C34.9041 21.216 34.6732 21.771 34.2116 22.2421C33.7499 22.7132 33.1949 22.9487 32.5466 22.9487ZM1.66699 29.295V27.8558C1.66699 26.8258 2.21088 25.9749 3.29866 25.3029C4.38644 24.631 5.79796 24.295 7.53324 24.295C7.85102 24.295 8.15519 24.3072 8.44574 24.3317C8.7363 24.3564 9.0131 24.3965 9.27616 24.4521C9.03671 24.8793 8.85185 25.3281 8.72158 25.7983C8.5913 26.2686 8.52616 26.7696 8.52616 27.3012V29.295H1.66699ZM11.667 29.295V27.42C11.667 26.0417 12.4375 24.9465 13.9787 24.1346C15.5195 23.3226 17.5296 22.9167 20.0091 22.9167C22.5119 22.9167 24.5249 23.3226 26.0482 24.1346C27.5719 24.9465 28.3337 26.0417 28.3337 27.42V29.295H11.667ZM32.5003 24.295C34.2503 24.295 35.66 24.631 36.7295 25.3029C37.7989 25.9749 38.3337 26.8258 38.3337 27.8558V29.295H31.4745V27.3012C31.4745 26.7696 31.4163 26.2686 31.2999 25.7983C31.1835 25.3281 31.0089 24.8793 30.7762 24.4521C31.0389 24.3965 31.316 24.3564 31.6074 24.3317C31.8988 24.3072 32.1964 24.295 32.5003 24.295Z" fill="#9747FF" />
          </svg></div>
          <div>
            <h4>एकूण विद्यार्थी</h4>
          <p>{dashboardCounts.totalStudents}</p>
          </div>
        </div>
        <div className="stat green">
          <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M7.6925 35C6.92528 35 6.28472 34.7431 5.77083 34.2292C5.25694 33.7153 5 33.0747 5 32.3075V26.6667H6.66667V32.3075C6.66667 32.5642 6.77347 32.7993 6.98708 33.0129C7.20069 33.2265 7.43583 33.3333 7.6925 33.3333H13.3333V35H7.6925ZM5 13.3333V7.6925C5 6.92528 5.25694 6.28472 5.77083 5.77083C6.28472 5.25694 6.92528 5 7.6925 5H13.3333V6.66667H7.6925C7.43583 6.66667 7.20069 6.77347 6.98708 6.98708C6.77347 7.20069 6.66667 7.43583 6.66667 7.6925V13.3333H5ZM18.0129 30.6025C15.8204 30.1922 13.939 29.2018 12.3688 27.6313C10.7982 26.061 9.80778 24.1796 9.3975 21.9871H11.0642C11.4403 23.7329 12.256 25.2335 13.5112 26.4888C14.7665 27.744 16.2671 28.5597 18.0129 28.9358V30.6025ZM9.3975 18.0129C9.80778 15.8204 10.7982 13.9374 12.3688 12.3637C13.939 10.7901 15.8204 9.80139 18.0129 9.3975V11.0642C16.2671 11.4403 14.7665 12.256 13.5112 13.5113C12.256 14.7665 11.4403 16.2671 11.0642 18.0129H9.3975ZM20 22.5C19.2969 22.5 18.7046 22.259 18.2229 21.7771C17.741 21.2954 17.5 20.7031 17.5 20C17.5 19.2906 17.741 18.6965 18.2229 18.2179C18.7046 17.7393 19.2969 17.5 20 17.5C20.7094 17.5 21.3035 17.7393 21.7821 18.2179C22.2607 18.6965 22.5 19.2906 22.5 20C22.5 20.7031 22.2607 21.2954 21.7821 21.7771C21.3035 22.259 20.7094 22.5 20 22.5ZM21.9871 30.6025V28.9358C23.7329 28.5597 25.2335 27.744 26.4888 26.4888C27.744 25.2335 28.5597 23.7329 28.9358 21.9871H30.6025C30.1986 24.1796 29.2099 26.061 27.6363 27.6313C26.0626 29.2018 24.1796 30.1922 21.9871 30.6025ZM28.9358 18.0129C28.5597 16.2671 27.744 14.7665 26.4888 13.5113C25.2335 12.256 23.7329 11.4403 21.9871 11.0642V9.3975C24.1796 9.80778 26.0626 10.7982 27.6363 12.3687C29.2099 13.939 30.1986 15.8204 30.6025 18.0129H28.9358ZM26.6667 35V33.3333H32.3075C32.5642 33.3333 32.7993 33.2265 33.0129 33.0129C33.2265 32.7993 33.3333 32.5642 33.3333 32.3075V26.6667H35V32.3075C35 33.0747 34.7431 33.7153 34.2292 34.2292C33.7153 34.7431 33.0747 35 32.3075 35H26.6667ZM33.3333 13.3333V7.6925C33.3333 7.43583 33.2265 7.20069 33.0129 6.98708C32.7993 6.77347 32.5642 6.66667 32.3075 6.66667H26.6667V5H32.3075C33.0747 5 33.7153 5.25694 34.2292 5.77083C34.7431 6.28472 35 6.92528 35 7.6925V13.3333H33.3333Z" fill="#499999" />
          </svg></div>
          <div>
            <h4>सक्रिय विद्यार्थी</h4>
           <p>{dashboardCounts.activeStudents}</p>
          </div>
        </div>
      </div>
      <div className="table-container">
        <table>

          <thead>
            <tr>
              <th>क्र.</th>
              <th>विद्यार्थी ID</th>
              <th>विद्यार्थी नाव</th>
              <th>परीक्षेचे नाव</th>

              <th>इयत्ता</th>
              <th>ईमेल</th>
              <th>नियुक्त शिक्षक</th>
              <th>स्थिती</th>
              <th>क्रिया</th>
            </tr>
          </thead>

          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((stu, index) => (
                <tr key={`${stu.id}-${index}`}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{stu.studentUniqueId}</td>
                  <td>{stu.studentName}</td>

                  <td>
                    {stu.softwares?.map(s => s.softwareName).join(", ")}
                  </td>

                  <td>{stu.standardName}</td>
                  <td>{stu.email}</td>

                  <td>{stu.teacherName}</td>
                  <td>
                    {stu.isActive ? "सक्रिय" : "निष्क्रिय"}
                  </td>


                  <td className="actions">
                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleViewClick(stu.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M12.0037 15.1538C13.0198 15.1538 13.8821 14.7981 14.5904 14.0868C15.2988 13.3754 15.6529 12.5117 15.6529 11.4955C15.6529 10.4793 15.2973 9.61708 14.5859 8.90875C13.8746 8.20042 13.0108 7.84625 11.9947 7.84625C10.9785 7.84625 10.1163 8.20192 9.40792 8.91325C8.69959 9.62458 8.34542 10.4883 8.34542 11.5045C8.34542 12.5207 8.70109 13.3829 9.41242 14.0913C10.1238 14.7996 10.9875 15.1538 12.0037 15.1538ZM11.9992 14.2C11.2492 14.2 10.6117 13.9375 10.0867 13.4125C9.56167 12.8875 9.29917 12.25 9.29917 11.5C9.29917 10.75 9.56167 10.1125 10.0867 9.5875C10.6117 9.0625 11.2492 8.8 11.9992 8.8C12.7492 8.8 13.3867 9.0625 13.9117 9.5875C14.4367 10.1125 14.6992 10.75 14.6992 11.5C14.6992 12.25 14.4367 12.8875 13.9117 13.4125C13.3867 13.9375 12.7492 14.2 11.9992 14.2ZM12.0019 18C9.83592 18 7.86192 17.4106 6.07992 16.2317C4.29792 15.0529 2.96334 13.4757 2.07617 11.5C2.96334 9.52433 4.29701 7.94708 6.07717 6.76825C7.85734 5.58942 9.83042 5 11.9964 5C14.1624 5 16.1364 5.58942 17.9184 6.76825C19.7004 7.94708 21.035 9.52433 21.9222 11.5C21.035 13.4757 19.7013 15.0529 17.9212 16.2317C16.141 17.4106 14.1679 18 12.0019 18Z" fill="#313030" />
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleEditClick(stu.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M5.02607 19.9157C4.74007 19.9734 4.49674 19.9019 4.29607 19.7014C4.09557 19.5008 4.02415 19.2574 4.08182 18.9714L4.72607 15.8369L8.16057 19.2714L5.02607 19.9157ZM8.92032 18.6234L5.37407 15.0772L15.7376 4.73294C16.0439 4.4266 16.4227 4.27344 16.8741 4.27344C17.3254 4.27344 17.7042 4.4266 18.0106 4.73294L19.2646 5.98694C19.5709 6.29327 19.7241 6.6721 19.7241 7.12344C19.7241 7.57477 19.5709 7.9536 19.2646 8.25994L8.92032 18.6234Z" fill="#4285F4" />
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleDeleteClick(index)} width="12" height="14" viewBox="0 0 14 16" fill="none">
                      <path d="M2.6155 15.7693C2.15517 15.7693 1.77083 15.6151 1.4625 15.3068C1.15417 14.9984 1 14.6141 1 14.1538V1.76925H0V0.769251H4V0H10V0.769251H14V1.76925H13V14.1538C13 14.6141 12.8458 14.9984 12.5375 15.3068C12.2292 15.6151 11.8448 15.7693 11.3845 15.7693H2.6155ZM4.80775 12.7693H5.80775V3.76925H4.80775V12.7693ZM8.19225 12.7693H9.19225V3.76925H8.19225V12.7693Z" fill="#FF1501" />
                    </svg>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" style={{ textAlign: "center" }}>
                  No records found
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>
      {showDeletePopup && (
        <div className="delete-popup-overlay" onClick={cancelDelete}>
          <div className="delete-popup-box delete-confirm-box" onClick={(e) => e.stopPropagation()}>
            <div className="delete-icon-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 32 36" fill="none">
                <path d="M6 36C4.9 36 3.95833 35.6083 3.175 34.825C2.39167 34.0417 2 33.1 2 32V6C1.43333 6 0.958333 5.80833 0.575 5.425C0.191667 5.04167 0 4.56667 0 4C0 3.43333 0.191667 2.95833 0.575 2.575C0.958333 2.19167 1.43333 2 2 2H10C10 1.43333 10.1917 0.958333 10.575 0.575C10.9583 0.191667 11.4333 0 12 0H20C20.5667 0 21.0417 0.191667 21.425 0.575C21.8083 0.958333 22 1.43333 22 2H30C30.5667 2 31.0417 2.19167 31.425 2.575C31.8083 2.95833 32 3.43333 32 4C32 4.56667 31.8083 5.04167 31.425 5.425C31.0417 5.80833 30.5667 6 30 6V32C30 33.1 29.6083 34.0417 28.825 34.825C28.0417 35.6083 27.1 36 26 36H6ZM26 6H6V32H26V6ZM12 28C12.5667 28 13.0417 27.8083 13.425 27.425C13.8083 27.0417 14 26.5667 14 26V12C14 11.4333 13.8083 10.9583 13.425 10.575C13.0417 10.1917 12.5667 10 12 10C11.4333 10 10.9583 10.1917 10.575 10.575C10.1917 10.9583 10 11.4333 10 12V26C10 26.5667 10.1917 27.0417 10.575 27.425C10.9583 27.8083 11.4333 28 12 28ZM20 28C20.5667 28 21.0417 27.8083 21.425 27.425C21.8083 27.0417 22 26.5667 22 26V12C22 11.4333 21.8083 10.9583 21.425 10.575C21.0417 10.1917 20.5667 10 20 10C19.4333 10 18.9583 10.1917 18.575 10.575C18.1917 10.9583 18 11.4333 18 12V26C18 26.5667 18.1917 27.0417 18.575 27.425C18.9583 27.8083 19.4333 28 20 28Z" fill="#FF0000" />
              </svg>
              <h3>विद्यार्थी हटवा</h3>
              <p>तुम्हाला हा विद्यार्थी कायमचा हटवायचा आहे का?</p>
            </div>
            <div className="delete-popup-buttons">
              <button className="delete-cancel-btn" onClick={cancelDelete}>नाही </button>
              <button className="delete-confirm-btn" onClick={confirmDelete}>होय </button>
            </div>
          </div>
        </div>
      )}

      <div className='que-pagination-container'>
        <div className="que-pagination-controlss">
          <button
            className="que-pagination-btn"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &lt;
          </button>

          {[...Array(totalPages).keys()]
            .map((_, i) => i + 1)
            .slice(
              Math.max(currentPage - 2, 0),
              Math.min(currentPage + 1, totalPages)
            )
            .map((page) => (
              <button
                key={page}
                className={`que-pagination-btn ${currentPage === page ? 'active' : ''
                  }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}

          <button
            className="que-pagination-btn"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
          {/* Rows per page and range info */}
          <div className="que-pagination-controls">
            <span className="que-rows-label">Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              className="que-rows-dropdown"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentManagment;
